import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const CuentaPagarApp = lazy(() => import('./view/pagar/CuentasPagar'))
const CuentaPagarEntradaRegistroApp = lazy(
  () => import('./view/pagar/CuentaPagarEntradaRegistro'),
)
const CuentaPagarMovimientoApp = lazy(() => import('./view/pagar/CuentasPagarMovimiento'))

export const cuentasRoutesMap = {
  pagar: {
    path: '/cuenta/pagar-entrada',
    name: 'Entrada',
  },
  pagarEntradaRegistro: {
    path: '/cuenta/pagar-entrada-registro',
    name: 'Nueva Cuenta por Entrada',
  },
  pagarMovimiento: {
    path: '/cuenta/pagar/movimiento/:id',
    name: 'Movimientos de Pago',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const cuentasRoutes = [
  {
    path: cuentasRoutesMap.pagar.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasRoutesMap.pagarEntradaRegistro.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarEntradaRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasRoutesMap.pagarMovimiento.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarMovimientoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default cuentasRoutes
